import React, { useEffect } from 'react';

const baseUrl = 'https://www.thomaspartydecor.com';

const buildFullTitle = (title) => {
  if (!title) {
    return 'Party Rentals Philadelphia & Delaware County | Thomas Party & Decor';
  }
  if (title.includes('Thomas Party')) {
    return title;
  }
  return `${title} | Thomas Party & Decor`;
};

const SEO = ({ title, description, keywords, canonical, ogType = 'website' }) => {
  const fullTitle = buildFullTitle(title);

  useEffect(() => {
    document.title = fullTitle;
  }, [fullTitle]);

  return (
    <>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={`${baseUrl}${canonical || ''}`} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={`${baseUrl}${canonical || ''}`} />
      <meta property="og:type" content={ogType} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
    </>
  );
};

export const JsonLd = ({ schema }) => (
  <script
    type="application/ld+json"
    dangerouslySetInnerHTML={{ __html: JSON.stringify(schema).replace(/</g, '\\u003c') }}
  />
);

export const ProductListSchema = ({ products, canonical }) => {
  if (!products || products.length === 0) return null;

  const schema = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    "name": "Thomas Party & Decor Products",
    "url": `${baseUrl}${canonical || ''}`,
    "numberOfItems": products.length,
    "itemListElement": products.map((product, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "item": {
        "@type": "Product",
        "name": product.name,
        "description": product.description,
        "image": product.image,
        "url": `${baseUrl}${canonical || ''}?item=${product.id}`,
        "sku": product.id,
        "brand": { "@type": "Brand", "name": "Thomas Party & Decor" },
        "offers": {
          "@type": "Offer",
          "price": product.price,
          "priceCurrency": "USD",
          "availability": "https://schema.org/InStock",
          "url": `${baseUrl}${canonical || ''}?item=${product.id}`,
          "businessFunction": "http://purl.org/goodrelations/v1#LeaseOut",
          "seller": { "@id": "https://www.thomaspartydecor.com/#business" }
        }
      }
    }))
  };

  return <JsonLd schema={schema} />;
};

export default SEO;
